import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  class: "customer-selector-add-text"
};
import { ref, computed, watch, h, useAttrs } from 'vue';
import CustomerTag from './CustomerTag.vue';
import CustomerPicker from './CustomerPicker.vue';
import { useFormDisabled, useFormSize } from 'element-plus';
import { getCustomer } from '@/api/customer';
export default /*@__PURE__*/Object.assign({
  inheritAttrs: false
}, {
  __name: 'index',
  props: {
    modelValue: {
      type: [Number, String, Array],
      default: undefined
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择客户'
    },
    maxSelect: {
      type: Number,
      default: null
    },
    excludeIds: {
      type: Array,
      default: () => []
    },
    hideAddButton: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'confirm'],
  setup(__props, {
    emit: __emit
  }) {
    // 客户选择图标组件 - 复用项目已有的内联SVG模式
    const CustomerIcon = {
      props: {
        size: {
          type: Number,
          default: 16
        }
      },
      render() {
        return h('svg', {
          fill: 'none',
          stroke: 'currentColor',
          viewBox: '0 0 24 24',
          style: {
            width: `${this.size}px`,
            height: `${this.size}px`
          }
        }, [h('path', {
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '2',
          d: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7v1h14v-1a7 7 0 00-7-7z'
        })]);
      }
    };
    const $props = __props;
    const $emits = __emit;
    const attrs = useAttrs();

    // 客户信息映射表，用于编辑时根据ID查找客户信息
    const customerMap = ref({});
    const normalizeCustomer = (customer, id) => {
      const data = customer?.data || customer || {};
      return {
        id: data.id ?? id,
        name: data.name || String(id),
        phone: data.phone || '',
        customerNo: data.customerNo || ''
      };
    };

    // 加载客户信息到映射表
    const loadCustomerInfo = async ids => {
      if (!ids || ids.length === 0) return;
      try {
        const missingIds = ids.filter(id => id && !customerMap.value[id]);
        const customers = await Promise.all(missingIds.map(async id => {
          try {
            return normalizeCustomer(await getCustomer(id), id);
          } catch (error) {
            console.error('加载客户信息失败:', error);
            return {
              id,
              name: String(id),
              phone: '',
              customerNo: ''
            };
          }
        }));
        customers.forEach(customer => {
          customerMap.value[customer.id] = customer;
        });
      } catch (error) {
        console.error('加载客户信息失败:', error);
      }
    };

    // 监听modelValue变化，加载客户信息
    watch(() => $props.modelValue, val => {
      if (!val) return;
      const ids = Array.isArray(val) ? val : [val];
      // 如果有纯ID需要查找客户信息
      const needLoad = ids.some(id => typeof id === 'number' && !customerMap.value[id]);
      if (needLoad) {
        loadCustomerInfo(ids);
      }
    }, {
      immediate: true
    });
    const valueArr = computed(() => {
      if (!$props.modelValue) return [];
      const arr = Array.isArray($props.modelValue) ? $props.modelValue : [$props.modelValue];
      return arr.map(item => {
        if (typeof item === 'object') {
          return item;
        }
        // 纯ID时尝试从映射表获取信息
        return customerMap.value[item] || {
          id: item,
          name: '',
          phone: '',
          customerNo: ''
        };
      });
    });
    const customerPickerRef = ref();
    const formDisabled = useFormDisabled();
    const formSize = useFormSize();
    const disabled = computed(() => {
      return formDisabled.value || $props.disabled;
    });
    const sizeName = computed(() => {
      const s = formSize.value || 'default';
      if (s === 'small') return 'small';
      if (s === 'large') return 'large';
      return 'default';
    });
    const isEmpty = computed(() => {
      if (!$props.modelValue) return true;
      return Array.isArray($props.modelValue) && $props.modelValue.length === 0;
    });
    const clickable = computed(() => !disabled.value && !$props.hideAddButton);
    const openCustomerPicker = () => {
      if (!clickable.value) return;
      customerPickerRef.value?.open();
    };
    const onPickerConfirm = selectedCustomers => {
      selectedCustomers.forEach(customer => {
        if (customer.id) {
          customerMap.value[customer.id] = {
            id: customer.id,
            name: customer.name || '',
            phone: customer.phone || '',
            customerNo: customer.customerNo || ''
          };
        }
      });
      $emits('confirm', selectedCustomers);
    };
    const onClose = id => {
      if (!$props.modelValue) return;
      if ($props.multiple && Array.isArray($props.modelValue)) {
        const newValue = $props.modelValue.filter(item => {
          const itemId = typeof item === 'object' ? item.id : item;
          return String(itemId) !== String(id);
        });
        $emits('update:modelValue', newValue);
      } else {
        $emits('update:modelValue', null);
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(CustomerPicker, {
        ref_key: "customerPickerRef",
        ref: customerPickerRef,
        multiple: __props.multiple,
        "model-value": __props.modelValue,
        "max-select": __props.maxSelect,
        "exclude-ids": __props.excludeIds,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.$emit('update:modelValue', $event)),
        onConfirm: onPickerConfirm
      }, null, 8, ["multiple", "model-value", "max-select", "exclude-ids"]), _createElementVNode("div", _mergeProps(_unref(attrs), {
        class: ["customer-selector", {
          'is-disabled': disabled.value,
          'is-empty': isEmpty.value,
          'is-clickable': clickable.value
        }],
        onClick: openCustomerPicker
      }), [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(valueArr.value, item => {
        return _openBlock(), _createBlock(CustomerTag, {
          closable: !disabled.value,
          disabled: disabled.value,
          key: typeof item === 'object' ? item.id : item,
          id: typeof item === 'object' ? item.id : item,
          name: typeof item === 'object' ? item.name : '',
          onClose: $event => onClose(typeof item === 'object' ? item.id : item)
        }, null, 8, ["closable", "disabled", "id", "name", "onClose"]);
      }), 128)), _withDirectives(_createElementVNode("span", {
        class: "customer-selector-placeholder"
      }, _toDisplayString(__props.placeholder), 513), [[_vShow, isEmpty.value]]), !__props.hideAddButton && !disabled.value ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: _normalizeClass(["customer-selector-add", `is-${sizeName.value}`]),
        onClick: _withModifiers(openCustomerPicker, ["stop"])
      }, [_createVNode(CustomerIcon, {
        size: sizeName.value === 'small' ? 12 : 14
      }, null, 8, ["size"]), _createElementVNode("span", _hoisted_1, _toDisplayString(isEmpty.value ? '选择' : ''), 1)], 2)) : _createCommentVNode("", true)], 16)], 64);
    };
  }
});